<template>
	<div class="nav-link-wrapper alerts">
		<router-link v-if="selectedAccount" class="nav-link" :to="{ name: 'Support', params: { user_uid: selectedAccount } }">
			<svgicon name="support" :fill="false"></svgicon>
			<span>{{ $t('base.general.support') }}</span>
		</router-link>
	</div>
</template>

<script>
export default {
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationSupport.vue